<template>
    <div>
        <Header>
            <div class="buttons-right">
                <save-button id="account-save" name="Account" :status="saving" @save="save()"></save-button>
            </div>
        </Header>

        <div class="page page--medium">

            <div class="block" v-if="!userProfile">
                <div class="loading-gif" >
                    <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                </div>
            </div>

            <div class="block block--account" v-if="userAccount">
                <h3 class="block__heading" v-t="'Account Details'"></h3>
                <div class="clearfix">
                    <div class="col-2">
                        <field :errors="errors" label="First Name" name="name">
                            <input id="account-first-name" type="text" v-model="userAccount.first_name">
                        </field>
                    </div>
                    <div class="col-2">
                        <field :errors="errors" label="Last Name" name="name">
                            <input id="account-last-name" type="text" v-model="userAccount.last_name">
                        </field>
                    </div>
                </div>
                <field :errors="errors" label="Email Address" name="email" help="Your account email address used to contact you.">
                    <input id="account-email" v-model="userAccount.email" type="text">
                </field>

                <field :errors="errors" class="field field-switch field-switch-inline">
                    <label class="switch">
                        <input v-model="userProfile.is_disabled" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label">
                        <span v-t="'Disable and unpublish your portfolio?'"></span>
                        <span class="small" v-t="'Enabling this option will hide your online portfolio, \'hibernating\' your account without wiping your data. It can be turned on or off at any time. If you are on a paid plan you will still be charged.'"></span>
                    </span>
                </field>

                <br>
                <router-link :to="{name: 'password'}" v-t="'Change Password?'"></router-link>
                <router-link :to="{name: 'delete'}" class="inline-right-btn" v-t="'Delete Account?'"></router-link>

            </div>

            <div class="block block--account" v-if="portfolio">
                <h3 class="block__heading" v-t="'Your Subscription'"></h3>

                    <div class="loading-gif" v-if="loading">
                        <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                    </div>

                  <div v-if="portfolio && !loading">
                    <h3>{{ portfolio.plan }}</h3>

                      <router-link
                      v-if="portfolio.account_type==='free' || portfolio.billing_method === 'promotion'"
                        class="inline-payment-history"
                        :to="{name: 'payments'}"
                        >Payment History</router-link
                      >

                    <a
                      v-if="portfolio.account_type === 'free' || portfolio.billing_method === 'promotion'"
                      class="button button--full"
                      :href="checkout_url"
                      >View Plans &amp; Upgrade &rarr;</a
                    >


                    <div v-if="portfolio.subscription_is_cancelled" class="clearfix">
                      <span
                        >Your subscription will expire on
                        {{ portfolio.billing_cancellation_effective_date }}</span
                      >
                      <br>
                      <br>
                    </div>

                    <span>
                      <div
                        v-if="portfolio.account_type !== 'free' && portfolio.billing_method !== 'promotion' && !portfolio.subscription_is_cancelled"
                        class="clearfix"
                      >
                        <div class="col-2">
                          <p>
                            <strong>Payment Method</strong><br />
                            <span v-if="portfolio.billing_method == 'stripe' && portfolio.last_4_digits">
                              Card ending {{ portfolio.last_4_digits }}
                              <a id="change-card-button" v-t="'Update'" :href="checkout_url + '/update-card/'">Update</a>
                            </span>

                            <span v-if="userProfile.billing_method == 'braintree'">
                              PayPal &nbsp;
                              <a class="small" @click="switchToCard()">Switch to paying by card?</a>
                            </span>

                            <span v-if="portfolio.billing_method === 'paddle'">
                              <span
                                v-if="portfolio.paddle_payment_method==='paypal'
                                "
                                >PayPal</span
                              >
                              <span
                                v-if="
                                  portfolio.paddle_payment_method==='card'
                                "
                                >Card <span v-if="portfolio.last_4_digits">ending {{ portfolio.last_4_digits }}</span
                              ></span>
                              &nbsp;
                              <a class="small" :href="checkout_url + '/update-paddle/'">Update</a>
                            </span>
                          </p>
                        </div>

                        <div v-if="portfolio.next_payment_date" class="col-2">
                          <p>
                            <strong>Next Payment</strong><br />
                            <span v-if="portfolio.next_payment_amount">{{portfolio.next_payment_amount}} on </span>{{ portfolio.next_payment_date }}
                          </p>
                        </div>
                      </div>

                      <a
                        v-if="showReactivateButton()"
                        class="button button--secondary button--inline button--right button--delete"
                        @click="reactivateSubscription()"
                        >Reactivate Subscription</a
                      >

                      <a
                        v-if="portfolio.account_type !== 'free' && portfolio.billing_method !== 'promotion'  && !portfolio.subscription_is_cancelled"
                        class="button button--secondary button--inline button--right button--delete"
                        @click="cancelSubscription()"
                        >Cancel Subscription</a
                      >
                      <a
                        v-if="portfolio.account_type == 'pro' && portfolio.billing_method !== 'promotion' && !portfolio.subscription_is_cancelled"
                        class="button button--secondary button--inline"
                        @click="switchPlan('downgrade')"
                        >Downgrade to Plus</a
                      >
                      <a
                        v-if="portfolio.account_type == 'plus' && portfolio.billing_method !== 'promotion' && !portfolio.subscription_is_cancelled"
                        class="button button--secondary button--inline"
                        @click="switchPlan('upgrade')"
                        >Upgrade to Pro</a
                      >
                      <router-link
                        v-if="portfolio.account_type!=='free' && portfolio.billing_method !== 'promotion'"
                        class="button button--secondary button--inline"
                        :to="{name: 'payments'}"
                        >Payment History</router-link
                      >

                      <a
                        v-if="
                          portfolio.billing_plan &&
                          portfolio.billing_plan.indexOf('monthly') !== -1 &&
                          !portfolio.subscription_is_cancelled
                        "
                        class="upgrade"
                        @click="switchPlan('annual-billing')"
                        ><strong>Switch to Annual Billing</strong> - Save the cost of
                        <span v-if="portfolio.account_type === 'plus'">2</span
                        ><span v-if="portfolio.account_type === 'pro'">3</span> monthly payments a year</a
                      >
                    </span>
                  </div>

            </div>

            <div class="block">
                <h3 class="block__heading">Your Privacy Rights: GDPR</h3>
                <div class="add-on">
                    <div class="add-on__content">
                        <p>Under the EU General Data Protection Regulation (GDPR) you have a legal right to the following:</p>

                        <ul>
                            <li>To request to view all the personal data we hold on you, to do this please email <a target="_blank" href="mailto:support@journoportfolio.com">support@journoportfolio.com</a>.</li>

                            <li>To request that all of the personal data we hold on you is erased or that we stop processing your data. To do this please <router-link :to="{name: 'delete'}">delete your account</router-link>.</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import SaveButton from '@/components/SaveButton.vue'

    import CURRENCIES from '@/constants/symbols.js'
    import { openGenericConfirmModal } from '@/utils'

    export default {
        components: {
            Header,
            Field,
            SaveButton
        },
        data () {
            return {
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                  loading: false,
                  has_billing_migration: false,
                  userProfile: null,
                  userAccount: null,
                  saving: false,
                  notificationTypes: null,
                  notificationSettings: null,
                  errors: {},
                  cancelToken: null,
                  paddle_sub: null,
                  upgrade_message: null,
                  switch_plan_action: null,
                  transactions: null,
                  show_popup: false,
                  LEGACY_PLANS: [
                      'plus2-12',
                      'usd-pro-12',
                      'usd-pro',
                      'usd-plus-12',
                      'usd-plus',
                      'plus',
                      'pro',
                      'plus2',
                      'plus-usd',
                      'pro-12',
                      'plus-12',
                      'paypal-usd-plus-12',
                      'paypal-usd-pro-12',
                      'paypal-usd-pro',
                      'paypal-usd-plus',
                  ]
            }
        },
          computed: {
            user() {
              return this.$store.getters['auth/user']
            },
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            },
            checkout_url() {
              if (window.location.hostname.indexOf('.journoportfolio') !== -1) {
                return (
                  'https://checkout.' +
                  window.location.hostname.split('.')[1] +
                  '.' +
                  window.location.hostname.split('.')[2]
                )
              }
              return 'https://checkout.journoportfolio.com'
            },
          },
        methods: {
            switchToCard(){
                window.Intercom('showNewMessage', "Hi, I'd like to switch to paying by card instead of paypal")
            },
            showReactivateButton(){
              if( this.has_billing_migration ) {
                return false
              }else if(this.portfolio){
                return this.portfolio.is_owner && this.portfolio.subscription_is_cancelled
              }else{
                return false
              }
            },
            save () {
                this.saving = true
                this.$http.put('/portfolio/profile/', this.userProfile).then(data => {
                    
                    this.userProfile = data.data
                    this.saving = true
                    this.$http.put('/user/account/', this.userAccount).then(data => {
                        this.saving = false
                        this.$store.dispatch('messages/success', this.$t('messages.account-saved'))
                        this.userAccount = data.data
                    }).catch(errors => {
                        this.saving = null
                        if(errors && errors.response && errors.response.data){
                            this.errors = errors.response.data
                        }
                    })

                }).catch(errors => {
                    this.saving = null
                    if(errors && errors.response && errors.response.data){
                        this.errors = errors.response.data
                    }
                })

            },
            interestedCustomDev (){
                window.Intercom('showNewMessage', this.$t('intercom.custom-dev'));
            },

            interestedForwarding  (){
                window.Intercom('showNewMessage', this.$t('intercom.email-forwarding'));
            },

            interestedEmail (){
                window.Intercom('showNewMessage', this.$t('intercom.email-account'));
            },

            replacePaypal () {
                window.Intercom('showNewMessage', this.$t('intercom.billing-method'));
            },


            renderCurrency(currency) {
              if (currency in CURRENCIES) {
                return CURRENCIES[currency]
              } else {
                return currency
              }
            },

            reactivateSubscription() {
              openGenericConfirmModal(
                this,
                'Reactivate your Cancelled Subscription?',
                'This will re-start your previously cancelled subscription. You will be billed on your usual billing cycle.',
                'Reactivate Subscription'
              )
                .then(() => {
                  this.loading = true
                  this.$http.post('/reactivate-cancelled/', {}).then((response) => {
                    this.loading = false
                    this.$store.dispatch('auth/reload')
                    this.$store.dispatch('messages/success', this.$t('Plan changed successfully'))
                  }).catch((errors) => {
                    var message = 'There was an error reactivating your plan'
                    if (
                      errors &&
                      errors.response &&
                      errors.response.status == 400 &&
                      errors.response.data &&
                      errors.response.data.error
                    ) {
                      message += ': ' + errors.response.data.error
                    }
                    this.$store.dispatch(
                      'messages/error',
                      message
                    )
                  })
                })
                .catch(() => {
                  this.loading = false
                })
            },

            switchPlan(action) {
                  this.switch_plan_action = action

                  if (action === 'downgrade') {
                    var title = 'Downgrade to Plus'
                    var text =
                      "Your custom domain will be suspended and won't be renewed. You will lose access to all Pro features immediately.<br><br>"
                    var button = 'Confirm Downgrade'

                  }

                  if (action === 'upgrade') {
                    var title = 'Upgrade to Pro'
                    var text =
                      'Get a custom domain name, article backups, automatic imports and more...<br><br>'
                    var button = 'Confirm Upgrade'

                  }

                  if (action === 'annual-billing') {
                    var title = 'Switch to Annual Billing'
                    var text = ''
                    var button = 'Confirm Switch'

                    if (this.portfolio.billing_method === 'braintree') {
                      window.Intercom('showNewMessage', "Hi, I'd like to switch to annual billing")
                      return
                    }
                  }

                  this.loading = true

                  this.$http.get('/switch-plan/?action=' + action, {}).then((response) => {
                    openGenericConfirmModal(this, title, text + response.data.message, button)
                      .then(() => {
                        this.$http.post('/switch-plan/?action=' + action, {}).then((response) => {
                          this.loading = false
                          this.$store.dispatch('auth/reload')
                          this.$store.dispatch('messages/success', this.$t('Plan changed successfully'))
                          this.$forceUpdate();
                        }).catch((errors) => {
                          this.loading = false
                          var message = 'There was an error switching your plan'
                          if (
                            errors &&
                            errors.response &&
                            errors.response.status == 400 &&
                            errors.response.data &&
                            errors.response.data.error
                          ) {
                            message += ': ' + errors.response.data.error
                          }
                          this.$store.dispatch(
                            'messages/error',
                            message
                          )
                        })
                      })
                      .catch(() => {
                        this.loading = false
                      })
                  }).catch((errors) => {
                    this.loading = false
                    var message = 'There was an error switching your plan'
                    if (
                      errors &&
                      errors.response &&
                      errors.response.status == 400 &&
                      errors.response.data &&
                      errors.response.data.error
                    ) {
                      message += ': ' + errors.response.data.error
                    }
                    this.$store.dispatch(
                      'messages/error',
                      message
                    )
                  })
            },

            cancelSubscription() {
                  openGenericConfirmModal(
                    this,
                    'Cancel Your Subscription',
                    '<p>This will set your subscription to not renew. You will continue to have access to your current plan until your current subscription period ends.</p><div class="alert"><strong>Please note that when your subscription period ends:</strong> <ul><li>Your custom domain will stop working, so no-one who knows your domain will be able to visit your site.</li><li>Any privacy options enabled on your portfolio will be disabled and your portfolio will become public.</li><li>The backup of your articles will be disabled.</li><li>All of your pages, except for your home page will be hidden which will negatively affect your Google ranking and traffic.</li><li>A maximum of 10 articles will be displayed on your portfolio.</li></ul></div>',
                    'Confirm Cancellation'
                  )
                    .then(() => {
                      this.loading = true
                      this.$http
                        .post('/downgrade/', {})
                        .then((data) => {
                          this.loading = false
                          this.$store.dispatch(
                            'messages/success',
                            this.$t('Your subscription has been cancelled')
                          )
                          this.$store.dispatch('auth/reload')
                          this.$forceUpdate();
                          window.location.reload()
                        })
                        .catch((errors) => {
                          this.loading = false
                          var message = 'There was an error switching your account to the free plan'
                          if (
                            errors &&
                            errors.response &&
                            errors.response.status == 400 &&
                            errors.response.data &&
                            errors.response.data.error
                          ) {
                            message += ': ' + errors.response.data.error
                          }
                          this.$store.dispatch(
                            'messages/error',
                            message
                          )
                        })
                    })
                    .catch(() => {})
            },

        },
        mounted () {

          this.$http
            .get('/portfolio/billing-migration/')
            .then((data) => {
              this.has_billing_migration = data.data.has_billing_migration
            })
            .catch(() => {})

            this.$http
              .get('/user/notifications/')
              .then((data) => {
                this.notificationSettings = data.data
              })
              .catch(() => {})

            this.$http
              .get('/notification-types/')
              .then((data) => {
                this.notificationTypes = data.data
              })
              .catch(() => {})

            this.$http
              .get('/portfolio/profile/')
              .then((data) => {
                this.userProfile = data.data
              })
              .catch(() => {})

            this.$http
              .get('/user/account/')
              .then((data) => {
                this.userAccount = data.data
              })
              .catch(() => {})

            var user = this.$store.getters['auth/user']
        }
    }
</script>